var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Paper, Stack, Typography } from "@mui/material";
import { format } from "date-fns";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useRetrieveUserLeagueMatchStatsPermissions } from "../api/PermissionApiProvider";
import { useBulkUpdatePlayerLeagueMatchStats, useCreateLeagueMatchResult, useRetrieveLeagueMatch, useUpdateLeagueMatchResult, } from "../api/SeasonApiProvider";
import { useRetrievePlayersByTeamId } from "../ApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { NotFound } from "../nav/NotFound";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
import { LeagueMatchStatsForm } from "./LeagueMatchStatsForm";
export var UpdatePlayerLeagueMatchStats = function () {
    var _a, _b, _c;
    var id = useNumericParams().id;
    var _d = useRetrieveLeagueMatch({ id: id }), leagueMatch = _d.data, leagueMatchIsLoading = _d.isLoading, leagueMatchError = _d.error;
    // Get league match stats permissions
    var _e = useRetrieveUserLeagueMatchStatsPermissions({
        leagueMatchId: id,
    }), leagueMatchStatsPermissions = _e.data, leagueMatchStatsPermissionsIsLoading = _e.isLoading, leagueMatchStatsPermissionsError = _e.error;
    var _f = leagueMatchStatsPermissions || {}, _g = _f.canModifyTeams, canModifyTeams = _g === void 0 ? [] : _g, _h = _f.canModifyResult, canModifyResult = _h === void 0 ? false : _h;
    // Check if user can modify either team (is a team manager or league admin)
    var homeTeamId = (_a = leagueMatch === null || leagueMatch === void 0 ? void 0 : leagueMatch.homeTeam) === null || _a === void 0 ? void 0 : _a.id;
    var awayTeamId = (_b = leagueMatch === null || leagueMatch === void 0 ? void 0 : leagueMatch.awayTeam) === null || _b === void 0 ? void 0 : _b.id;
    var canModifyHomeTeam = homeTeamId
        ? canModifyTeams.includes(homeTeamId)
        : false;
    var canModifyAwayTeam = awayTeamId
        ? canModifyTeams.includes(awayTeamId)
        : false;
    var _j = useRetrievePlayersByTeamId({ teamId: homeTeamId }), homeTeamPlayers = _j.data, homeTeamPlayersError = _j.error, homeTeamPlayersIsLoading = _j.isLoading;
    var _k = useRetrievePlayersByTeamId({ teamId: awayTeamId }), awayTeamPlayers = _k.data, awayTeamPlayersError = _k.error, awayTeamPlayersIsLoading = _k.isLoading;
    var navigate = useNavigate();
    var _l = useBulkUpdatePlayerLeagueMatchStats(leagueMatch, function () { }, function () { return undefined; }, function () { return undefined; }), bulkUpdateStatsIsLoading = _l.isLoading, bulkUpdateStatsIsError = _l.isError, bulkUpdateStatsMutateAsync = _l.mutateAsync;
    var _m = useUpdateLeagueMatchResult(leagueMatch, function () { }, function () { return undefined; }, function () { return undefined; }), updateResultIsLoading = _m.isLoading, updateResultIsError = _m.isError, updateResultMutateAsync = _m.mutateAsync;
    var _o = useCreateLeagueMatchResult(leagueMatch, function () { }, function () { return undefined; }, function () { return undefined; }), createResultIsLoading = _o.isLoading, createResultIsError = _o.isError, createResultMutateAsync = _o.mutateAsync;
    if (leagueMatchIsLoading || leagueMatchStatsPermissionsIsLoading) {
        return _jsx(Loading, {});
    }
    if (leagueMatchError) {
        return _jsx(ErrorView, { error: leagueMatchError });
    }
    if (leagueMatchStatsPermissionsError) {
        return _jsx(ErrorView, { error: leagueMatchStatsPermissionsError });
    }
    // User needs to be league admin or team manager to access this page
    // For now, we'll allow anyone who can view the league (simplified permission check)
    if (canModifyTeams.length === 0) {
        return _jsx(NotFound, {});
    }
    if ((homeTeamId && homeTeamPlayersIsLoading) ||
        (awayTeamId && awayTeamPlayersIsLoading) ||
        bulkUpdateStatsIsLoading ||
        updateResultIsLoading ||
        createResultIsLoading ||
        !leagueMatch) {
        return _jsx(Loading, {});
    }
    var onSubmit = function (leagueMatchResult, playerLeagueMatchStats) { return __awaiter(void 0, void 0, void 0, function () {
        var hasResult, base, query;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, bulkUpdateStatsMutateAsync(Object.values(playerLeagueMatchStats))];
                case 1:
                    _a.sent();
                    if (!canModifyResult) return [3 /*break*/, 5];
                    if (!(leagueMatch.leagueMatchResult === null)) return [3 /*break*/, 3];
                    return [4 /*yield*/, createResultMutateAsync(leagueMatchResult)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, updateResultMutateAsync(leagueMatchResult)];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5:
                    hasResult = canModifyResult || leagueMatch.leagueMatchResult !== null;
                    base = "/leagues/".concat(leagueMatch.leagueId, "/seasons/").concat(leagueMatch.seasonId);
                    query = "division=".concat(leagueMatch.division, "&gameweek=").concat(leagueMatch.round);
                    navigate(hasResult
                        ? "".concat(base, "?tab=scores&").concat(query)
                        : "".concat(base, "?tab=fixtures&").concat(query));
                    return [2 /*return*/];
            }
        });
    }); };
    if (homeTeamPlayersError ||
        awayTeamPlayersError ||
        (homeTeamId && homeTeamPlayers === undefined) ||
        (awayTeamId && awayTeamPlayers === undefined)) {
        return _jsx(ErrorView, { error: homeTeamPlayersError || awayTeamPlayersError });
    }
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: updateResultIsError, message: "Failed to update league match result! Please try again." }), _jsx(ErrorSnackbar, { open: createResultIsError, message: "Failed to create league match result! Please try again." }), _jsx(ErrorSnackbar, { open: bulkUpdateStatsIsError, message: "Failed to update player league match stats! Please try again." }), _jsx(Paper, { elevation: 0, sx: { p: 2, mb: 3, bgcolor: "grey.50", borderRadius: 2 }, children: _jsxs(Stack, { spacing: 1, alignItems: "center", children: [_jsx(Typography, { variant: "body2", color: "text.secondary", children: format(new Date(leagueMatch.kickOff), "EEEE, MMMM do yyyy • h:mm a") }), _jsxs(Stack, { direction: "row", spacing: 2, alignItems: "center", children: [_jsx(Typography, { component: Link, to: "/teams/".concat(leagueMatch.homeTeam.id), variant: "h6", fontWeight: 600, sx: {
                                        textDecoration: "none",
                                        color: "text.primary",
                                        "&:hover": { color: "primary.main" },
                                    }, children: leagueMatch.homeTeam.name }), _jsx(Typography, { variant: "h6", color: "text.secondary", children: "v" }), _jsx(Typography, { component: Link, to: "/teams/".concat(leagueMatch.awayTeam.id), variant: "h6", fontWeight: 600, sx: {
                                        textDecoration: "none",
                                        color: "text.primary",
                                        "&:hover": { color: "primary.main" },
                                    }, children: leagueMatch.awayTeam.name })] }), ((_c = leagueMatch.venue) === null || _c === void 0 ? void 0 : _c.name) && (_jsxs(Typography, { variant: "body2", color: "text.secondary", children: [leagueMatch.venue.name, leagueMatch.pitchName && " - ".concat(leagueMatch.pitchName)] }))] }) }), _jsx(LeagueMatchStatsForm, { homeTeamPlayers: (homeTeamPlayers !== null && homeTeamPlayers !== void 0 ? homeTeamPlayers : []).filter(function (p) { return p.isActive; }), awayTeamPlayers: (awayTeamPlayers !== null && awayTeamPlayers !== void 0 ? awayTeamPlayers : []).filter(function (p) { return p.isActive; }), onSubmit: onSubmit, leagueMatch: leagueMatch, canModifyHomeTeam: canModifyHomeTeam, canModifyAwayTeam: canModifyAwayTeam, canModifyResult: canModifyResult })] }));
};
